<div class="cw-flex-column">
  <phscw-global-help-toolbar class="toolbar"></phscw-global-help-toolbar>

  <div class="cw-module text">
    <phscw-global-help-text [popupData]="popupData" [allowEditmode]="allowEditHelpentry"></phscw-global-help-text>
    <phscw-global-help-documents></phscw-global-help-documents>
    @if (allowAssignHelpentryModules) {
      <phscw-global-help-modules></phscw-global-help-modules>
    }
    @if (allowAllowAssignHelpentryRoles) {
      <phscw-global-help-roles></phscw-global-help-roles>
    }
  </div>
</div>
